// Zenklub services.
import { HttpClient } from '@angular/common/http';
// Angular modules.
import { Injectable } from '@angular/core';
import {
	ITaxonomy,
	ITaxonomyGroupContext,
	ITaxonomyGroupResponse,
} from 'app/interfaces/search.interface';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

/**
 * The taxonomy service is a 'almost-static' information that are loaded from the backend, and will help us to better
 * link and categorize information. The things here are really cacheable, since the information is, theoretically, not
 * to change frequently.
 *
 * Important data to load from the taxonomy endpoints:
 * - appointment reasons
 * - professional specialties and complaints
 */
@Injectable()
export class TaxonomyService {
	constructor(private httpClient: HttpClient) {}

	public getTaxonomyList(category: string): Observable<ITaxonomy[]> {
		const url = `taxonomy/search?category=${category}`;
		return this.httpClient.get<ITaxonomy[]>(url).pipe(shareReplay(1));
	}

	public getTaxonomyGroup(
		context: ITaxonomyGroupContext
	): Observable<ITaxonomyGroupResponse[]> {
		const url = `taxonomy?context=${context}`;
		return this.httpClient
			.get<ITaxonomyGroupResponse[]>(url)
			.pipe(shareReplay(1));
	}

	public getTaxonomyReasons(): Observable<ITaxonomy[]> {
		const url = `taxonomy?context=session_reason`;
		return this.httpClient.get<ITaxonomyGroupResponse[]>(url).pipe(
			shareReplay(1),
			map((values) => {
				return values
					.reduce(
						(acc, item) => [
							...acc,
							...item.children.map((v) => ({ id: v.taxonomyId, name: v.name })),
						],
						[]
					)
					.sort((a, b) => (a.name > b.name ? 1 : -1));
			})
		);
	}

	public getNoshowReasons(): Observable<ITaxonomy[]> {
		return this.httpClient.get<ITaxonomy[]>('taxonomy/search?category=no-show');
	}
}
